import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';

const Container = styled.section`
  width: 100%;
  max-width: 1200px;
  margin: 4rem auto 0;
  padding: 0 2rem;
`;

const Title = styled.h2`
  font-size: 2.25rem;
  font-weight: 700;
  color: white;
  margin: 0 0 1.25rem 0;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;

  @media (min-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

const Card = styled.article`
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.03);
  padding: 1rem;
  cursor: pointer;
  transition: transform 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(96, 165, 250, 0.65);
  }
`;

const Cover = styled.div`
  width: 100%;
  height: 180px;
  border-radius: 10px;
  margin-bottom: 0.9rem;
  background: ${props => props.image
    ? `url(${props.image}) center/cover no-repeat`
    : 'linear-gradient(135deg, rgba(96,165,250,0.25), rgba(99,102,241,0.22))'};
`;

const Name = styled.h3`
  margin: 0 0 0.45rem 0;
  color: white;
  font-size: 1.2rem;
  font-weight: 700;
`;

const Description = styled.p`
  margin: 0;
  color: #cbd5e1;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const ActionsRow = styled.div`
  margin-top: 0.9rem;
`;

export default function PortfolioProjects({ projects = [] }) {
  const navigate = useNavigate();

  if (!projects || projects.length === 0) return null;

  return (
    <Container>
      <Title>Projects</Title>
      <Grid>
        {projects.map((project) => {
          const coverImage = project.cover_image_url ||
            (Array.isArray(project.screenshots_urls) && project.screenshots_urls.length > 0
              ? project.screenshots_urls[0]
              : null);

          return (
            <Card
              key={project.id || project.title}
              onClick={() => project.id && navigate(`/projects/${project.id}`)}
            >
              <Cover image={coverImage} />
              <Name>{project.title || 'Untitled Project'}</Name>
              <Description>{project.description || 'No description provided.'}</Description>
              <ActionsRow>
                <Button
                  label="View project"
                  icon="pi pi-arrow-right"
                  className="p-button-sm p-button-text"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (project.id) navigate(`/projects/${project.id}`);
                  }}
                />
              </ActionsRow>
            </Card>
          );
        })}
      </Grid>
    </Container>
  );
}
